import { sort } from '@ellf/common-utils';
import { MenuItem, SubMenuItems } from './menu.model';

const anagraphs: SubMenuItems[] = [
  {
    label: 'Contratti',
    link: '/contract',
    permissions: ['access_all', 'access_contract'],
  },
  {
    label: 'Periodi',
    link: '/practice',
    permissions: ['access_all', 'access_practice'],
  },
  {
    label: 'Ordini di ingresso',
    link: '/order',
    permissions: ['access_all', 'access_order'],
  },
  {
    label: 'Fornitori',
    link: '/supplier',
    permissions: ['access_all', 'access_supplier'],
  },
  {
    label: 'Produttori',
    link: '/manufacturer',
    permissions: ['access_all', 'access_manufacturer'],
  },
  {
    label: 'Presidi',
    link: '/medicalUnit',
    permissions: ['access_all', 'access_medicalUnit'],
  },
  {
    label: 'Centri di costo',
    link: '/costCenter',
    permissions: ['access_all', 'access_costCenter'],
  },
  {
    label: 'Ubicazioni',
    link: '/location',
    permissions: ['access_all', 'access_location'],
  },
  {
    label: 'Centri di costo - Ubicazioni',
    link: '/costCenterLocation',
    permissions: ['access_all', 'access_costCenterLocation'],
  },
];

const assets: SubMenuItems[] = [
  {
    label: 'Apparecchiature',
    link: '/asset',
    permissions: ['access_all', 'access_asset'],
  },
  {
    label: 'Collaudi',
    link: '/testing',
    permissions: ['access_all', 'access_testing'],
  },
  {
    label: 'IN / OUT',
    link: '/inOutAsset',
    permissions: ['access_all', 'access_inOutAsset'],
  },
];

const moduli: SubMenuItems[] = [
  {
    label: 'Richiesta Fuori uso',
    link: '/outOfOrderAssetRequest',
    permissions: ['access_all', 'access_outOfOrderAssetRequest'],
  },
  {
    label: 'DDT',
    link: '/ddt',
    permissions: ['access_all', 'access_ddt'],
  },
  {
    label: 'Attestazione avvenuta formazione',
    link: '/trainingCertificate',
    permissions: ['access_all', 'access_trainingCertificate'],
  },
  {
    label: 'Richiesta VPN',
    link: '/vpnRequest',
    permissions: ['access_all', 'access_vpnRequest'],
  },
  {
    label: 'Scheda di presa in carico',
    link: '/takingCharge',
    permissions: ['access_all', 'access_takingCharge'],
  },
  // TODO: - voci commentate finché non saranno pubblicati i Moduli Verdi
  // {
  //   label: 'Richiesta Apparecchiature/Accessori/Dispositivi medici/Beni',
  //   link: '/assetOrAccessoryRequest',
  //   permissions: ['access_all', 'access_assetOrAccessoryRequest'],
  // },
  // {
  //   label: 'Richiesta Trasferimento/Scarico',
  //   link: '/transferOrUnloadingRequest',
  //   permissions: ['access_all', 'access_transferOrUnloadingRequest'],
  // },
];

const auth: SubMenuItems[] = [
  {
    label: 'Utenti',
    link: '/user',
    permissions: ['access_all', 'access_user'],
  },
  {
    label: 'Ruoli',
    link: '/role',
    permissions: ['access_all', 'access_role'],
  },
];

const types: SubMenuItems[] = [
  {
    label: 'Classi di costo',
    link: '/costClass',
    permissions: ['access_all', 'access_costClass'],
  },
  // {
  //   label: 'Qualifiche',
  //   link: '/jobTitle',
  //   permissions: ['access_all', 'access_jobTitle'],
  // },
  {
    label: 'Stati collaudo',
    link: '/testingStatus',
    permissions: ['access_all', 'access_testingStatus'],
  },
  {
    label: 'Stati ordine',
    link: '/orderStatus',
    permissions: ['access_all', 'access_orderStatus'],
  },
  {
    label: 'Tipi apparecchiatura',
    link: '/assetType',
    permissions: ['access_all', 'access_assetType'],
  },
  {
    label: 'Tipi collaudo',
    link: '/testingType',
    permissions: ['access_all', 'access_testingType'],
  },
  {
    label: 'Tipi documento',
    link: '/documentType',
    permissions: ['access_all', 'access_documentType'],
  },
  {
    label: 'Tipi fornitura',
    link: '/supplyType',
    permissions: ['access_all', 'access_supplyType'],
  },
  {
    label: 'Tipi manutenzioni pianificate',
    link: '/scheduledMaintenanceType',
    permissions: ['access_all', 'access_scheduledMaintenanceType'],
  },
  {
    label: 'Stati manutenzioni pianificate',
    link: '/scheduledMaintenanceStatus',
    permissions: ['access_all', 'access_scheduledMaintenanceStatus'],
  },
  {
    label: 'Risultati manutenzioni pianificate',
    link: '/scheduledMaintenanceResult',
    permissions: ['access_all', 'access_scheduledMaintenanceResult'],
  },
  {
    label: 'Stati apparecchiature',
    link: '/assetStatus',
    permissions: ['access_all', 'access_assetStatus'],
  },
  {
    label: 'Priorità di intervento sulle apparecchiature',
    link: '/assetInterventionPriority',
    permissions: ['access_all', 'access_assetInterventionPriority'],
  },
  {
    label: 'Tipi di solleciti per manutenzioni correttive',
    link: '/correctiveMaintenanceReminderType',
    permissions: ['access_all', 'access_correctiveMaintenanceReminderType'],
  },
  {
    label: 'Tipi di azioni per manutenzioni correttive',
    link: '/correctiveMaintenanceActionType',
    permissions: ['access_all', 'access_correctiveMaintenanceActionType'],
  },
  {
    label: 'Risultati manutenzioni correttive',
    link: '/correctiveMaintenanceResult',
    permissions: ['access_all', 'access_correctiveMaintenanceResult'],
  },
  {
    label: 'Stati manutenzioni correttive',
    link: '/correctiveMaintenanceStatus',
    permissions: ['access_all', 'access_correctiveMaintenanceStatus'],
  },
  {
    label: 'Tipi di solleciti per manutenzioni pianificate',
    link: '/scheduledMaintenanceReminderType',
    permissions: ['access_all', 'access_scheduledMaintenanceReminderType'],
  },
];

const maintenance: SubMenuItems[] = [
  {
    label: 'Pianificate',
    link: '/scheduledMaintenance',
    permissions: ['access_all', 'access_scheduledMaintenance'],
  },
  {
    label: 'Correttive',
    link: '/correctiveMaintenance',
    permissions: ['access_all', 'access_correctiveMaintenance'],
  },
  {
    label: 'Gas Medicali',
    link: '/medicalGasRequest',
    permissions: ['access_all', 'access_medicalGasRequest'],
  },
];

const statistics: SubMenuItems[] = [
  {
    label: 'Manutenzioni Correttive',
    link: '/correctiveMaintenanceStatistics',
    permissions: ['access_all', 'access_correctiveMaintenanceStatistics'],
  },
];

export const MENU: MenuItem[] = [
  {
    label: 'Home',
    icon: 'home',
    link: '/',
  },
  {
    label: 'Anagrafiche',
    icon: 'mail',
    subMenus: [
      {
        subMenuItems: anagraphs,
      },
    ],
    permissions: ['access_all'],
  },
  {
    label: 'Tipologie',
    icon: 'archive',
    subMenus: [
      {
        subMenuItems: types.sort((i1, i2) => sort(i1, i2, 'label')),
      },
    ],
    permissions: ['access_all'],
  },
  {
    label: 'Apparecchiature',
    icon: 'framer',
    subMenus: [
      {
        subMenuItems: assets,
      },
    ],
  },
  {
    label: 'Manutenzioni',
    icon: 'briefcase',
    subMenus: [
      {
        subMenuItems: maintenance,
      },
    ],
  },
  {
    label: 'Moduli',
    icon: 'file-text',
    subMenus: [
      {
        subMenuItems: moduli,
      },
    ],
  },
  {
    label: 'Utenti',
    icon: 'user',
    subMenus: [
      {
        subMenuItems: auth,
      },
    ],
    permissions: ['access_all'],
  },
  // solo in locale per super admin
  // {
  //   label: 'Statistiche',
  //   icon: 'bar-chart',
  //   subMenus: [
  //     {
  //       subMenuItems: statistics,
  //     },
  //   ],
  //   permissions: ['access_correctiveMaintenanceStatistics'],
  // },
];
